"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorABIs = void 0;
exports.errorABIs = [
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "minWaitInSeconds",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "available",
                "type": "uint256"
            }
        ],
        "name": "AggregateValueRateLimitReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "minWaitInSeconds",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "available",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "TokenRateLimitReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantEnterPausedMarket",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepRewardToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InterMintNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotEmpty",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintTokensCantBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughRedeemTokens",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingAfterRedeem",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughUnderlyingForMint",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPausedMarketCanBeUnlisted",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OverThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Reentered",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizeTokenNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalBorrowsNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TotalSupplyNotZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "capacity",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "requested",
                "type": "uint256"
            }
        ],
        "name": "AggregateValueMaxCapacityExceeded",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "minWaitInSeconds",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "available",
                "type": "uint256"
            }
        ],
        "name": "AggregateValueRateLimitReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BucketOverfilled",
        "type": "error"
    },
    {
        "inputs": [
            {
                "components": [
                    {
                        "internalType": "bool",
                        "name": "isEnabled",
                        "type": "bool"
                    },
                    {
                        "internalType": "uint256",
                        "name": "capacity",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "rate",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct RateLimiter.Config",
                "name": "config",
                "type": "tuple"
            }
        ],
        "name": "DisabledNonZeroRateLimit",
        "type": "error"
    },
    {
        "inputs": [
            {
                "components": [
                    {
                        "internalType": "bool",
                        "name": "isEnabled",
                        "type": "bool"
                    },
                    {
                        "internalType": "uint256",
                        "name": "capacity",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "rate",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct RateLimiter.Config",
                "name": "rateLimiterConfig",
                "type": "tuple"
            }
        ],
        "name": "InvalidRatelimitRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCallableByAdminOrOwner",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RateLimitMustBeDisabled",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "capacity",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "requested",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "TokenMaxCapacityExceeded",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "minWaitInSeconds",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "available",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "TokenRateLimitReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidPrice",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidProxy",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EmptyAdapterAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EmptyFeedAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EmptyMaxStalePeriod",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EmptyPendlePtOracle",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EmptyPythOracle",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDecimals",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidFeedDecimals",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidPrice",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnknownSource",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnsupportedSource",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroValueNotAllowed",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "rewardRates",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "rewardsDuration",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "num_periods_elapsed",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "balance",
                "type": "uint256"
            }
        ],
        "name": "NoEnoughReward",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "GroupIdMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OneOfRedeemTokensAndRedeemAmountMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrCapper",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtocolIsPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "AddReservesOverflow",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowAndDepositBackFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BorrowPaused",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdThreshold",
                "type": "uint256"
            }
        ],
        "name": "BorrowValueMustBeLargerThanThreshold",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantExitMarketWithNonZeroBorrowBalance",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "CantSweepUnderlying",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ComptrollerMismatch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EitherAssetOrDebtMustBeZero",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "groupId",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "cDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suDepositVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "cBorrowVal",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "suBorrowVal",
                "type": "uint256"
            }
        ],
        "name": "EitherAssetOrDebtMustBeZeroInGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpiredSignature",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientCollateral",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InsufficientShortfall",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidBlockNumber",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidCloseFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidComptroller",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidDiscountRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidExchangeRate",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidGroupId",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInterestRateModel",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidMinSuBorrowValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReduceAmount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidReserveFactor",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureForRedeemFaceValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSignatureLength",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidTimestamp",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsMax",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_RepayAmountIsZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateBorrow_SeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateCollateralMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "LiquidateMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketAlreadyListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketCanOnlyInitializeOnce",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MarketNotListed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MinDelayNotReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NoRedemptionProvider",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotEnoughForSeize",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotLiquidatableYet",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotSuToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyAdminOrPauser",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyListedCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyPendingAdmin",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OnlyRedemptionManager",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "PriceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedeemTransferOutNotPossible",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSeizeTooMuch",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RedemptionSignerNotInitialized",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesCashNotAvailable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReduceReservesMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "RepayBorrowMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SeizePaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Seize_LiquidatorIsBorrower",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SenderMustBeCToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetInterestRateModelMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SetReservesFactorMarketNotFresh",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "SupplyCapReached",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenInOrAmountInMustBeZero",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferInFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TokenTransferOutFailed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TooMuchRepay",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferNotAllowed",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferPaused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "UnderlyingBalanceError",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ZeroAddressNotAllowed",
        "type": "error"
    }
];
//# sourceMappingURL=errorABIs.js.map